import { render } from "./CardResumo.vue?vue&type=template&id=09ae6139&scoped=true"
import script from "./CardResumo.vue?vue&type=script&lang=js"
export * from "./CardResumo.vue?vue&type=script&lang=js"

import "./CardResumo.vue?vue&type=style&index=0&id=09ae6139&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ae6139"]])

export default __exports__